import * as types from './types';
import actionCreatorFactory from 'typescript-fsa';
import { GenActionFactoryName } from 'shared/helpers/redux-helpers';
import { ISite, SiteSetupDTO } from 'shared/api/api';

const actionCreator = actionCreatorFactory(GenActionFactoryName('site'));

export const getSiteAsync = actionCreator.async<{}, ISite, { code: number; message: string }>(types.LOAD);
export const saveSiteAsync = actionCreator.async<ISite, string, { code: number; message: string }>(types.SAVE_SITE);
export const createSiteAsync = actionCreator.async<SiteSetupDTO, string, { code: number; message: string }>(
	types.CREATE_SITE,
);
export const getAllSitesAsync = actionCreator.async<{}, ISite[], { code: number; message: string }>(types.GET_ALL_SITES);
export const migrationDownstreamAsync = actionCreator.async<{ siteId: string, entities: string[] },void, { code: number; message: string }>(types.MIGRATION_DOWNSTREAM);
export const migrationToArchiveAsync = actionCreator.async< string,void, { code: number; message: string }>(types.MIGRATION_TO_ARCHIVE);
export const migrationFromArchiveAsync = actionCreator.async<string,void, { code: number; message: string }>(types.MIGRATION_FROM_ARCHIVE);
export const getArchivedSites = actionCreator.async<{}, ISite[], { code: number; message: string }>(types.GET_ARCHIVED_SITES);
